import React from 'react';
import {MANUAL_CALCULATION_MEASURE, MANUAL_CALCULATION_ROW_TYPES} from "../../constants";
import {deleteManualCalculateRow, updateManualCalculateRow} from "../../../../actions/sqftManualCalculationFunctions";
import {connect} from "react-redux";
import sqftConfig from "../canvas/store/sqftConfig";

const SqftBacksplashRow = (props) => {
  const {row, rowIndex, rowLetter, deleteManualCalculateRow, updateManualCalculateRow} = props;
  const handleDeleteClick = () => {
    deleteManualCalculateRow(MANUAL_CALCULATION_ROW_TYPES.backsplashRows, row.id)
  };
  const handleUpdateClick = (event, measure) => {
    event.preventDefault();

    updateManualCalculateRow(MANUAL_CALCULATION_ROW_TYPES.backsplashRows, row, {[measure]:event.target.value});
  };

  return (
    <div className="row body-row" data-index={rowIndex}>
      <div className="col-xs-2">
        {rowLetter}
      </div>
      <div className="col-xs-4">
        <input type="number"
               className="input-length"
               value={row.length}
               placeholder={sqftConfig.getMeasureUnitPostfix()}
               onChange={(e) => {handleUpdateClick(e, MANUAL_CALCULATION_MEASURE.length)}}/>
      </div>
      <div className="col-xs-2"/>
      <div className="col-xs-4">
        <input type="number"
               className="input-height"
               value={row.height}
               placeholder={sqftConfig.getMeasureUnitPostfix()}
               onChange={(e) => {handleUpdateClick(e, MANUAL_CALCULATION_MEASURE.height)}}/>
      </div>
      <div className="col-xs-2 circle">
        <span className="js-remove-row" onClick={handleDeleteClick}/>
      </div>
    </div>

  )
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = {
  deleteManualCalculateRow,
  updateManualCalculateRow
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftBacksplashRow);
